import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { achievements } from "../../data/constants";
import { fadeUp, sealIn, staggerContainer, viewport } from "../../utils/motion";

// "Achievements Unlocked" — the one place the design contract allows a circle.
// dell-1996 reserves `rounded.full` for award seals (DESIGN.md:485), which is
// exactly what these are: a flat ring with a hard bevel, no gradient, no glow.

// auto-fit rather than a fixed column count, so the row stays balanced as
// achievements are added or removed.
const Row = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 24px 20px;
  justify-items: center;

  @media (max-width: 520px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Item = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  max-width: 190px;
`;

const Seal = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  border-radius: 9999px;
  background: ${({ theme }) => theme.biome.about.bg};
  border: 3px solid ${({ $tint }) => $tint};
  box-shadow: ${({ theme }) => theme.bevel} ${({ theme }) => theme.frameInk};

  font-family: ${({ theme }) => theme.fonts.ui};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  color: ${({ $tint }) => $tint};
`;

const Caption = styled.span`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 12px;
  line-height: 1.3;
  color: ${({ theme }) => theme.biome.about.muted};
`;

// The seals land one at a time, each with a short spring — "unlocking".
const Achievements = () => (
  <Row
    variants={staggerContainer(0.09)}
    initial="hidden"
    whileInView="show"
    viewport={viewport}
  >
    {achievements.map((a) => (
      <Item key={a.id} variants={fadeUp}>
        <Seal $tint={a.tint} variants={sealIn}>
          {a.badge}
        </Seal>
        <Caption>{a.label}</Caption>
      </Item>
    ))}
  </Row>
);

export default Achievements;
